import _ from 'underscore';

export default (function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx) {
    var translateFn = TranslateService.instant;

    function wrappedLoadSave(action, model) {
        var promise = action.call(undefined, model);
        return promise.then(function (submissionDTO) {
            return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelCtx);
        });
    }

    var isComplexQuoteAma = false;

    var processError = function processError(xArgs) {
        var extraArgs = xArgs.extraArgs;
        if (extraArgs && extraArgs.error) {
            if (angular.isArray(extraArgs.error)) {
                var theError = _.first(_.where(extraArgs.error, function (err) {
                    return err.baseError;
                }));
                var errorCode = '' + theError.baseError.error.data.appErrorCode;
                isComplexQuoteAma = /^9.*/.test(errorCode);
                return { isComplexQuoteAma: isComplexQuoteAma };
            }
        }
    };

    var ACTION_MSG = {
        saveSubmission: {
            error: {
                title: 'quoteandbind.common.flow.error.Error',
                message: 'quoteandbind.common.flow.error.An error has occurred...',
                noModal: true
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        },
        complexQuoteAma: function complexQuoteAma(xArgs) {
            var result = processError(xArgs);
            return {
                error: {
                    title: 'quoteandbind.common.flow.error.Error',
                    message: 'quoteandbind.common.flow.error.An error has occurred...',
                    noModal: function noModal() {
                        return result && result.isComplexQuoteAma;
                    }
                },
                progress: {
                    message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
                }
            };
        }

    };

    var ACTIONS = {
        saveDraftSubmission: function saveDraftSubmission(_ref) {
            var submission = _ref.value;
            return wrappedLoadSave(LoadSaveService.saveSubmission, submission);
        }
    };

    return {
        contactDetails: function contactDetails(step, junction) {
            step('cppContactDetails', true).onNext.branch(function (model) {
                return model.quoteID.value ? 'cppPostContactDetails' : 'cppContactDetailsComplete';
            }).skipOnResumeIf(function (_ref2) {
                var submission = _ref2.value;
                return submission.persons[0] && submission.persons[0].emailAddress1;
            }).isValid(function (model, form) {
                return model.aspects.valid && model.aspects.subtreeValid && form.valid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Your Info');
            });

            junction('cppPostContactDetails').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSG.saveSubmission).thenGoTo('cppContactDetailsComplete', 'complexQuoteAma');

            junction('cppContactDetailsComplete');
        },
        coverables: function coverables(step, junction) {
            step('cppPrequalQuestions', true).onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSG.complexQuoteAma).thenGoTo('cppGeneralCoverages', 'complexQuoteAma').skipOnResumeIf(function (_ref3, _ref4) {
                var submission = _ref3.value;
                var gatewayportalnewsubmission = _ref4.gatewayportalnewsubmission;

                if (gatewayportalnewsubmission) {
                    return false;
                }

                //Skipping past cppPrequalQuestions is currently not wanted, always return false
                //                    if (submission.lobData.commercialPackage && submission.lobData.commercialPackage.preQualQuestionSets) {
                //                        const answerValues = _.values(submission.lobData.commercialPackage.preQualQuestionSets[0].answers);
                //                        return answerValues.some(value => value !== null);
                //                    }

                return false;
            }).isValid(function (model, formValid) {
                return model.aspects.valid && model.aspects.subtreeValid && formValid.valid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Qualification');
            });

            step('cppGeneralCoverages').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSG.complexQuoteAma).thenGoTo('cppDiscounts', 'complexQuoteAma')
            //               .skipOnResumeIf(({
            //                   value: submission
            //               }) => {
            //                   const coverages = submission.lobData.businessOwners.coverages.lobCoverages;
            //                   return submission.baseData.periodStatus === 'Quoted' ||
            //                       (coverages && !_.findWhere(coverages, {
            //                           isValid: false
            //                       }));
            //                })
            .isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.cpp.wizard.step.General Coverages');
            });

            step('cppDiscounts').onNext.goTo('cppCoverablesComplete', 'error')
            //                .skipOnResumeIf(({
            //                    value: submission
            //                }) => {
            //                    const coverages = submission.lobData.businessOwners.coverages.lobCoverages;
            //                    return submission.baseData.periodStatus === 'Quoted' ||
            //                        (coverages && !_.findWhere(coverages, {
            //                            isValid: false
            //                        }));
            //                })
            .isValid(function (model, formValid) {
                return model.aspects.valid && model.aspects.subtreeValid && formValid.valid;
            }).label(function () {
                return translateFn('quoteandbind.cpp.wizard.step.Discounts');
            });

            junction('cppCoverablesComplete');
        } /*,
          moreInfo: (step, junction) => {
             step('cppPolicyInfo', true)
                 .skipOnResumeIf(({
                     value: submission
                 }) => {
                     return submission.baseData &&
                         submission.baseData.accountHolder &&
                         submission.baseData.accountHolder.emailAddress1 && (
                             submission.baseData.accountHolder.homeNumber ||
                             submission.baseData.accountHolder.workNumber ||
                             submission.baseData.accountHolder.cellNumber
                         );
                 })
                 .onNext.goTo('cppMoreInfoComplete')
                 .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                 .label(() => translateFn('quoteandbind.wizard.step.Policy Info'));
               junction('cppMoreInfoComplete');
          }*/
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=cpp!./app/customer/js/src/edge/quoteandbind/ama/cpp/config/FlowConfig.js
// module id = 386
// module chunks = 0